import { Box, styled, Typography } from '@material-ui/core';
import { SETVIImage } from '@setvi/shared/components';
import { TextColor } from '@setvi/shared/enums';

const StyledTitle = styled(Typography)({
  color: TextColor.SlateGrey,
  fontSize: 14,
  lineHeight: '20px',
  fontWeight: 600
});

interface ProductsEmptyStateProps {
  title: string;
}

export const ProductsEmptyState = ({ title }: ProductsEmptyStateProps) => (
  <Box
    flex={1}
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    gridGap="24px">
    <SETVIImage src="/images/no-products-found.svg" alt={title} />
    <StyledTitle>{title}</StyledTitle>
  </Box>
);
